<template>
  <v-app>
    <v-main>
      <home />
    </v-main>
  </v-app>
</template>

<script>
import home from './components/home'
export default {
  name: 'App',
  components: {
    home
  },

  data: () => ({
    //
  })
}
</script>
<style scoped>
@font-face {
  font-family: "Prompt";
  src: local("Prompt"),
    url(./assets/font/Prompt/Prompt-Regular.ttf) format("truetype");
}
@font-face {
  font-family: "Sarabun";
  src: local("Sarabun"),
    url(./assets/font/Sarabun/Sarabun-Regular.ttf) format("truetype");
}
html,
body {
  font-family: "Sarabun", sans-serif;
}

#app {
  font-family: "Sarabun", sans-serif;
}
</style>
